import { render, staticRenderFns } from "./eventComp_mode_24.vue?vue&type=template&id=2b8f57b2&scoped=true"
import script from "./eventComp_mode_24.vue?vue&type=script&lang=js"
export * from "./eventComp_mode_24.vue?vue&type=script&lang=js"
import style0 from "./eventComp_mode_24.vue?vue&type=style&index=0&id=2b8f57b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f57b2",
  null
  
)

export default component.exports